import * as z from "zod/v4";

export const verifyMailbox = {
  name: "verifyMailbox" as const,
  input: z.object({ token: z.string() }),
  output: z.literal(true),
};
